import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HotCallStatusService } from 'src/app/common/services/hot-call-status.service';
import { GET_DASHBOARD, GET_RECENT_HOT_CALLS } from '../../common/graphql/queries';
import { CommonserviceService } from 'src/app/common/services/commonservice.service';
import { DataService } from 'src/app/common/services/data.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { ErrorHandlerService } from 'src/app/common/services/error-handler.service';
import { recentHotCallsSignal } from 'src/app/common/signals/recent-hot-call-signal';
import { userApplConfigSignal } from 'src/app/common/signals/user-profile-signal';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  activeHotCallsCount: number = 0;
  closedHotCallsCount: number = 0;
  isNewCreateHotCall = true;
  myHotCallCount: number = 0
  isLoading: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly commonsService: CommonserviceService,
    private readonly translate: TranslateService,
    private readonly hotCallStatusService: HotCallStatusService,
    private readonly dataService: DataService,
    private readonly spinner: SpinnerService,
    private readonly errorService: ErrorHandlerService
  ) {}

  ngOnInit(): void {
    this.errorService.clearErrorMessage();
    this.spinner.show();
    const userId = this.dataService.getUserId();
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      this.translate.use(savedLanguage);
    }
    const shopName = userApplConfigSignal().shopName;
    const plantName = userApplConfigSignal().plantName;
    const lineName = userApplConfigSignal().lineName;
    this.commonsService.getHcmData(GET_DASHBOARD, { userId, shopName, lineName, plantName }).subscribe({
      next: (response) => {
      if (response?.data?.getDashBoard) {
          this.activeHotCallsCount = response.data.getDashBoard.activeHotCallCount;
          this.closedHotCallsCount = response.data.getDashBoard.closedHotCallCount;
          this.myHotCallCount = response.data.getDashBoard.myHotCallCount;
      } else {
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      }
      if(response?.errors){
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      }
      },
      error: (error) => {
      this.errorService.setErrorMessage([]);
      this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
      }
    });
    this.getRecentHotCalls();
  }

  public routeActiveHotCall(): void {
    this.router.navigateByUrl('active-hot-calls');
  }

  public routeClosedHotCall(): void {
    this.router.navigateByUrl('closed-hot-calls');
  }

  public routeMyHotCall(): void {
    this.router.navigateByUrl('my-hot-calls');
  }
  
  public createNewHotCall(data: string) : void {
    const section = this.isNewCreateHotCall ? '1' : '3';
    sessionStorage.setItem('currentSection', section); 
    this.dataService.updateStepNumber(parseInt(section));
    this.hotCallStatusService.setData(data);
    this.router.navigate(['/create-hot-call']);
  }

  public navigateToEditProfile():void{
    this.router.navigate(['/edit-profile']);
  }

  public getRecentHotCalls(): void { 
    const userId = this.dataService.getUserId();
    this.commonsService.getHcmData(GET_RECENT_HOT_CALLS, { userId }).subscribe({
    next: (response) => {
    if (response?.data?.getRecentHotCalls.length > 0) {
      this.isNewCreateHotCall = false;
      recentHotCallsSignal.update(currentValue => {
        return [response.data.getRecentHotCalls[0], ...currentValue];
      });
    } 
    if(response?.errors){
      this.spinner.hide();
      this.errorService.setErrorMessage([]);
    }
    },
    error: (error) => {
    this.errorService.setErrorMessage([]);
    this.spinner.hide();
    },
    complete: () => {
      this.spinner.hide();
    }
  });
  }
}
 
